import DOMPurify from "dompurify";

export const sanitizeHTML = (dirty = "") => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      "p",
      "b",
      "i",
      "u",
      "strong",
      "em",
      "ul",
      "ol",
      "li",
      "a",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "img",
      "blockquote",
      "br",
      "hr",
      "span",
      "div",
      "table",
      "thead",
      "tbody",
      "tr",
      "th",
      "td",
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "width", "height"],
    FORBID_ATTR: ["onerror", "onclick", "onload", "onmouseover", "style"],
    FORBID_TAGS: [
      "script",
      "iframe",
      "object",
      "embed",
      "form",
      "input",
      "button",
    ],
  });
};
